module.exports = __webpack_public_path__ + "img/logo.522a3511.jpeg";